import { toValue, type MaybeRefOrGetter } from 'vue'
import { orderKeys } from '../orderQueryKeys'
import { getOrderReceipt } from '../orderEndpoints'
import { useLazyOrderFileQuery } from './useLazyOrderFileQuery'

/** The order's receipt PDF, fetched on demand and cached per order. */
export function useOrderReceiptFileQuery(
  orderId: MaybeRefOrGetter<string>,
  orderReference: MaybeRefOrGetter<string>,
) {
  return useLazyOrderFileQuery(
    () => orderKeys.receipt(toValue(orderId)),
    () => getOrderReceipt(toValue(orderId), toValue(orderReference)),
  )
}
